import React from 'react'
import { AppFormLayoutContext } from './AppFormLayout'

export interface IProps {
	tabId: number
	className?: string
	style?: React.CSSProperties
}

export default class AppFormTab extends React.Component<IProps> {
	render() {
		const { tabId } = this.props

		return (
			<AppFormLayoutContext.Consumer>
				{context => {
					return (
						<div
							className={`app-form-layout ${this.props.className || ''}`}
							style={this.props.style}
							hidden={!(tabId === context.tabId)}
						>
							{this.props.children}
						</div>
					)
				}}
			</AppFormLayoutContext.Consumer>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppFormTab.tsx